import {customElement, property} from 'lit/decorators.js';
import {ActionType, ButtonType} from './model';
import {html, LitElement, nothing} from 'lit';
import style from './ny-button.scss?inline';

@customElement('ny-button')
export class NyButton extends LitElement {

  @property({type: Boolean, reflect: true}) active: boolean | undefined = undefined;
  @property({type: Boolean, reflect: true}) disabled = false;
  @property() buttonType: ButtonType = 'standard-width-button';
  @property() actionType: ActionType = 'primary';
  @property() styleOverwrite: string | undefined = undefined;
  @property() type: string = 'button';
  
  private readonly selfControlled: boolean = true;
  
  constructor() {
    super();
    this.selfControlled = this.active === undefined;
  }

  private get isToggleable() {
    return this.buttonType === 'outlined-toggle-button';
  }

  private getButtonContent() {
    switch (this.buttonType) {
      case 'icon-button':
        return html`<slot name="svg"></slot>`;
      case 'standard-width-icon-button':
        return html`
          <span class="textAndIcon">
            <slot name="svg"></slot>
            <slot name="buttonLabel"></slot>
          </span>
        `;
      case 'two-line-high-width-button':
        return html`
          <span class="twoLineButton">
            <slot name="buttonLabel"></slot>
            <slot class="subText" name="buttonSubLabel"></slot>
          </span>
        `;
      default:
        return html`<slot name="buttonLabel"></slot>`;
    }
  }

  private handleClick(e: MouseEvent) {
    if (this.disabled) {
      e.stopImmediatePropagation();
      return;
    }

    if (this.isToggleable) {
      if (this.selfControlled) {
        this.active = !this.active;
      }
    }

    if (this.type === 'submit') {
      this.closest('form')?.requestSubmit();
    }
  }

  render() {
    let toggleClass: symbol | string = nothing;

    if (!this.disabled && this.isToggleable) {
      toggleClass = this.active ? 'toggle-on' : 'toggle-off';
    }
    
    return html`
      <button
        part='button'
        class=${toggleClass}
        style=${this.styleOverwrite ?? nothing}
        type=${this.type}
        actionType=${this.actionType}
        buttonType=${this.buttonType}
        ?disabled=${this.disabled}
        @click=${this.handleClick}
      >
        ${this.getButtonContent()}
      </button>
      <style>${style}</style>
    `;
  }
}